import { createLogger } from '../../Utils/Logger';
import { getSystemInstanceTypeName } from '../Decorators';
/**
 * 实体处理器列表管理器
 * 管理场景中的所有实体系统
 */
export class EntityProcessorList {
    constructor() {
        this._processors = [];
        this._isDirty = false;
    }
    /**
     * 设置为脏状态，需要重新排序
     */
    setDirty() {
        this._isDirty = true;
    }
    /**
     * 添加实体处理器
     * @param processor 要添加的处理器
     */
    add(processor) {
        this._processors.push(processor);
        this.setDirty();
    }
    /**
     * 移除实体处理器
     * @param processor 要移除的处理器
     */
    remove(processor) {
        const index = this._processors.indexOf(processor);
        if (index !== -1) {
            this._processors.splice(index, 1);
        }
    }
    /**
     * 获取指定类型的处理器
     * @param type 处理器类型
     */
    getProcessor(type) {
        for (const processor of this._processors) {
            if (processor instanceof type) {
                return processor;
            }
        }
        return null;
    }
    /**
     * 开始处理
     *
     * 对所有处理器进行排序以确保正确的执行顺序。
     */
    begin() {
        this.sortProcessors();
    }
    /**
     * 结束处理
     */
    end() {
        // 清理处理器
        for (const processor of this._processors) {
            try {
                processor.reset();
            }
            catch (error) {
                EntityProcessorList._logger.error(`Error in processor ${getSystemInstanceTypeName(processor)}:`, error);
            }
        }
        this._isDirty = false;
        this._processors.length = 0;
    }
    /**
     * 更新所有处理器
     */
    update() {
        this.sortProcessors();
        for (const processor of this._processors) {
            try {
                processor.update();
            }
            catch (error) {
                EntityProcessorList._logger.error(`Error in processor ${getSystemInstanceTypeName(processor)}:`, error);
            }
        }
    }
    /**
     * 后期更新所有处理器
     */
    lateUpdate() {
        for (const processor of this._processors) {
            processor.lateUpdate();
        }
    }
    /**
     * 排序处理器
     */
    sortProcessors() {
        if (this._isDirty) {
            this._processors.sort((a, b) => a.updateOrder - b.updateOrder);
            this._isDirty = false;
        }
    }
    /** 获取处理器列表 */
    get processors() {
        return this._processors;
    }
    /** 获取处理器数量 */
    get count() {
        return this._processors.length;
    }
}
EntityProcessorList._logger = createLogger('EntityProcessorList');
//# sourceMappingURL=EntityProcessorList.js.map